import React from "react";
import {
  DeviceDesktopOutlined,
  GoogleDriveColored,
  ImageSquareOutlined,
  OneDriveColored,
} from "@toddle-edu/ds-icons";

export const getModelOptions = () => {
  return [
    {
      key: "vertexai:gemini-2-0-flash",
      label: "Gemini 2.0 Flash",
    },
    {
      key: "vertexai:gemini-2-5-flash",
      label: "Gemini 2.5 Flash",
    },
    {
      key: "vertexai:gemini-2-5-pro",
      label: "Gemini 2.5 Pro",
    },
    {
      key: "vertexai:gemini-3-flash",
      label: "Gemini 3 Flash",
    },
    {
      key: "openai:gpt-4o",
      label: "GPT-4o",
    },
    {
      key: "openai:gpt-4.1",
      label: "GPT-4.1",
    },
    {
      key: "openai:gpt-4.1-mini",
      label: "GPT-4.1 Mini",
    },
    {
      key: "openai:gpt-4.1-nano",
      label: "GPT-4.1 Nano",
    },
    {
      key: "openai:gpt-5",
      label: "GPT-5",
    },
    {
      key: "bedrock:claude-3-haiku",
      label: "Claude 3 Haiku",
    },
    {
      key: "bedrock:claude-3.5-sonnet",
      label: "Claude 3.5 Sonnet (Old)",
    },
    {
      key: "bedrock:claude-3.5-sonnet-v2",
      label: "Claude 3.5 Sonnet - V2",
    },
    {
      key: "bedrock:claude-3.7-sonnet",
      label: "Claude 3.7 Sonnet",
    },
    {
      key: "bedrock:claude-4-sonnet",
      label: "Claude 4 Sonnet",
    },
    {
      key: "bedrock:claude-4.5-sonnet",
      label: "Claude 4.5 Sonnet",
    },
    {
      key: "vertexai:claude-4-5-sonnet",
      label: "VertexAI - Claude 4.5 Sonnet",
    },
    {
      key: "alibaba:qwen3.5-plus",
      label: "Qwen 3.5 Plus",
    },
    {
      key: "alibaba:deepseek-v3.2",
      label: "DeepSeek V3.2",
    },
    {
      key: "stability:stable-image-core",
      label: "Stable Image Core",
    },
    {
      key: "openai:o3",
      label: "OpenAI O3",
    },
    {
      key: "vertexai:gemini-3-pro-image-preview",
      label: "Nano Banana Pro",
    },
    {
      key: "vertexai:gemini-2-5-flash-image",
      label: "Nano Banana",
    },
  ];
};

export const REASONING_EFFORT_TOKENS_MAP = {
  low: 1024,
  medium: 1536,
  high: 2048,
};

export const getMoreFilterOptions = ({ selectedModel }) => {
  switch (selectedModel) {
    case "bedrock:claude-3.7-sonnet":
    case "bedrock:claude-4-sonnet":
    case "bedrock:claude-4.5-sonnet":
      return [
        {
          key: "reasoningEffort",
          label: "Reasoning effort",
          type: "SINGLE_SELECT_DROPDOWN",
          options: [
            {
              key: "NONE",
              label: "None",
            },
            {
              key: "LOW",
              label: "Low",
            },
            {
              key: "MEDIUM",
              label: "Medium",
            },
            {
              key: "HIGH",
              label: "High",
            },
          ],
        },
      ];
    case "vertexai:gemini-3-flash":
      return [
        {
          key: "reasoningEffort",
          label: "Reasoning effort",
          type: "SINGLE_SELECT_DROPDOWN",
          options: [
            {
              key: "NONE",
              label: "Minimal",
            },
            {
              key: "LOW",
              label: "Low",
            },
            {
              key: "MEDIUM",
              label: "Medium",
            },
            {
              key: "HIGH",
              label: "High",
            },
          ],
        },
      ];
    case "vertexai:gemini-2-5-pro":
    case "openai:o3":
      return [
        {
          key: "reasoningEffort",
          label: "Reasoning effort",
          type: "SINGLE_SELECT_DROPDOWN",
          options: [
            {
              key: "LOW",
              label: "Low",
            },
            {
              key: "MEDIUM",
              label: "Medium",
            },
            {
              key: "HIGH",
              label: "High",
            },
          ],
        },
      ];
    case "vertexai:gemini-3-pro-image-preview":
    case "vertexai:gemini-2-5-flash-image":
      return [
        {
          key: "aspectRatio",
          label: "Aspect ratio",
          type: "SINGLE_SELECT_DROPDOWN",
          options: [
            {
              key: "16:9",
              label: "16:9",
            },
            {
              key: "1:1",
              label: "1:1",
            },
            {
              key: "9:16",
              label: "9:16",
            },
            {
              key: "3:4",
              label: "3:4",
            },
            {
              key: "4:3",
              label: "4:3",
            },
            {
              key: "3:2",
              label: "3:2",
            },
            {
              key: "2:3",
              label: "2:3",
            },
            {
              key: "5:4",
              label: "5:4",
            },
            {
              key: "4:5",
              label: "4:5",
            },
            {
              key: "21:9",
              label: "21:9",
            },
          ],
        },
      ];
    case "stability:stable-image-core":
      return [
        {
          key: "aspectRatio",
          label: "Aspect ratio",
          type: "SINGLE_SELECT_DROPDOWN",
          options: [
            {
              key: "16:9",
              label: "16:9",
            },
            {
              key: "1:1",
              label: "1:1",
            },
            {
              key: "21:9",
              label: "21:9",
            },
            {
              key: "2:3",
              label: "2:3",
            },
            {
              key: "3:2",
              label: "3:2",
            },
            {
              key: "9:16",
              label: "9:16",
            },
            {
              key: "9:21",
              label: "9:21",
            },
          ],
        },
      ];
  }
};
export const TOOLS_ENABLED_MODELS = [
  //old keys
  //new keys
  "openai:gpt-4o",
  "openai:gpt-4o-mini",
  "openai:gpt-4.1",
  "openai:gpt-4.1-mini",
  "openai:gpt-4.1-nano",
  "openai:chatgpt-4o-latest",
  "bedrock:claude-3.5-sonnet",
  "bedrock:claude-3.5-sonnet-v2",
  "bedrock:claude-3.7-sonnet",
  "vertexai:gemini-2-0-flash",
  "vertexai:gemini-2-5-flash",
  "vertexai:gemini-2-5-pro",
  "openai:o3",
  "bedrock:claude-4-sonnet",
  "vertexai:gemini-3-flash",
  "alibaba:qwen3.5-plus",
  "alibaba:deepseek-v3.2",
];

export const getToolOptions = () => {
  return [
    {
      value: "internet_browsing",
      label: "Internet browsing",
    },
    {
      value: "search_v2",
      label: "Search V2 (multi-query)",
    },
    {
      value: "run_python_code",
      label: "Python code interpreter",
    },
    {
      value: "run_python_code_v2",
      label: "Python code interpreter (V2)",
    },
    {
      value: "store_bio",
      label: "Store bio",
    },
    {
      value: "open_url",
      label: "Open URL",
    },
    {
      value: "wolfram_alpha",
      label: "Wolfram Alpha",
    },
    {
      value: "flag_message",
      label: "Flagging message",
    },
    {
      value: "execute_clickhouse_query",
      label: "Clickhouse SQL executor",
    },
    {
      value: "get_clickhouse_schema_and_instruction",
      label: "Get Clickhouse schema and instruction",
    },
    {
      value: "process_spreadsheet",
      label: "Process Spreadsheet Attachment",
    },
    {
      value: "query_knowledge_base",
      label: "Query Knowledge Base",
    },
    {
      value: "get_planner_element_list",
      label: "Get planner element list",
    },
    {
      value: "set_template_fields",
      label: "Set template fields",
    },
    {
      value: "commit_final_unit_flow_to_unit_plan",
      label: "Commit final unit flow to unit plan",
    },
    {
      value: "manage_working_memory",
      label: "Manage working memory",
    },
    {
      value: "get_assessment_tool_details",
      label: "Get assessment tool details",
    },
    {
      value: "get_clickhouse_schema_and_consideration",
      label: "Get Clickhouse schema and consideration",
    },
    {
      value: "get_school_configuration",
      label: "Get school configuration",
    },
  ];
};

export const VALID_FILE_TYPES_FOR_AI = [
  // "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  // "application/msword", // .doc
  // "application/pdf", // pdf
  // "text/plain", // txt
  // "text/csv", // csv
  // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  // "application/vnd.ms-excel", // .xls
  // "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
  // "application/vnd.ms-powerpoint", // .ppt
  "image/jpeg", // .jpeg
  "image/jpg", // .jpg
  "image/png", // .png
  "image/gif", // .gif
];

export const CREATE_DROPDOWN_OPTIONS = [
  {
    key: "upload_device",
    label: "common:upload_device",
    icon: <DeviceDesktopOutlined size={"xx-small"} />,
  },
  {
    key: "add_google_drive",
    label: "common:add_google_drive",
    icon: <GoogleDriveColored size={"xx-small"} />,
  },
  {
    key: "add_one_drive",
    label: "common:add_one_drive",
    icon: <OneDriveColored size={"xx-small"} />,
  },
];

export const CREATE_DROPDOWN_OPTIONS_FOR_INLINE_IMAGE = [
  {
    key: "upload_image",
    label: "Upload Inline Image",
    icon: <ImageSquareOutlined size={"xx-small"} />,
  },
];

export const getAspectRationOptions = () => {
  return [
    {
      key: "16:9",
      label: "16:9",
    },
    {
      key: "1:1",
      label: "1:1",
    },
    {
      key: "21:9",
      label: "21:9",
    },
    {
      key: "2:3",
      label: "2:3",
    },
    {
      key: "3:2",
      label: "3:2",
    },
    {
      key: "9:16",
      label: "9:16",
    },
    {
      key: "9:21",
      label: "9:21",
    },
  ];
};

export const getImageTypeOptions = () => {
  return [
    {
      key: "jpeg",
      label: "JPEG",
    },
    {
      key: "png",
      label: "PNG",
    },
  ];
};

export const IMAGE_GENERATION_MODELS = [
  "stability:stable-image-core",
  "vertexai:gemini-3-pro-image-preview",
  "vertexai:gemini-2-5-flash-image",
];

export const MULTIMODAL_RESPONSE_MODELS = [
  "vertexai:gemini-3-pro-image-preview",
  "vertexai:gemini-2-5-flash-image",
];

export const processMessageContent = content => {
  // Content can have text and multiple <img> tags in between the text lines.
  const result = [];
  let currentText = "";

  // Split the input by image tags
  const textParts = content.split(/<img[^>]*>/); // It will have all the text parts. first part will be text until before the first image tag.
  const imgMatches = content.match(/<img[^>]*>/g) || [];

  for (let i = 0; i < textParts.length; i++) {
    // Add text part if not empty
    if (textParts[i].trim()) {
      currentText = textParts[i].trim();
      result.push({
        type: "text",
        text: currentText,
      });
    }

    // Add image if there's a match for this position
    if (i < imgMatches.length) {
      const srcMatch = imgMatches[i].match(/src="([^"]*)"/); // Extract the src attribute from the <img> tag
      if (srcMatch && srcMatch[1]) {
        result.push({
          type: "image_url",
          image_url: { url: srcMatch[1] },
        });
      }
    }
  }
  return result;
};
